import { IDynamicForm, IReducerState } from "config";
import { logout } from "store/actions/authentication";
import { fetchDynamicForm, initFormFlow } from "store/actions/flow";

import { createReducer, isAllOf, isAnyOf, PayloadAction } from "@reduxjs/toolkit";

export interface IDynamicFormState extends IDynamicForm, IReducerState {}

const defaultState: IDynamicFormState = {
  description: "",
  expiration: undefined,
  flow: { slug: "" },
  id: "",
  groups: [],
  hasLoaded: false,
  isLoading: false,
  items: [],
  layout: "vertical",
  leadingNavigationButton: undefined,
  slug: "",
};

/* ------------------    ADD MATCHERS     ------------------ */
const isDynamicFormPending = isAnyOf(fetchDynamicForm.pending, initFormFlow.pending);

const isDynamicFormResolved = isAnyOf(fetchDynamicForm.fulfilled, fetchDynamicForm.rejected);

const isNotDynamicFormModalLayout = (
  action: PayloadAction<IDynamicForm>
): action is PayloadAction<IDynamicForm> => {
  return action.payload?.layout !== "modal";
};

const isDynamicFormScreenFulfilled = isAllOf(
  fetchDynamicForm.fulfilled,
  isNotDynamicFormModalLayout
);

/* ------------------    REDUCER     ------------------ */
const dynamicForm = createReducer(defaultState, builder => {
  builder
    .addCase(initFormFlow.pending, () => defaultState)
    .addCase(logout, () => defaultState)
    .addMatcher(isDynamicFormScreenFulfilled, (state, action) => {
      const dynamicForm = action.payload;

      state.description = dynamicForm.description;
      state.flow = dynamicForm.flow;
      state.id = dynamicForm.id;
      state.groups = dynamicForm.groups || [];
      state.items = dynamicForm.items;
      state.layout = dynamicForm.layout;
      state.leadingNavigationButton = dynamicForm.leadingNavigationButton;
      state.slug = dynamicForm.slug;
      state.expiration = dynamicForm.expiration;
    })
    .addMatcher(isDynamicFormPending, state => {
      state.hasLoaded = false;
      state.isLoading = true;
    })
    .addMatcher(isDynamicFormResolved, state => {
      state.hasLoaded = true;
      state.isLoading = false;
    });
});

export default dynamicForm;
